(function () {
    'use strict';

    angular
        .module('ib-new-seat-map-module')
        .directive('ibTouch', ibTouch);

    ibTouch.$inject = ['$window', '$timeout', '$rootScope'];
    function ibTouch ($window, $timeout, $rootScope) {
        return {
            restrict: 'A',
            link: link
        };

        function link (scope, element) {
            const legend: any = document.getElementById('legend');
            const infoButton: any = document.getElementById('infoLegendButton');

            element.on('touchstart', () => {
                legend.classList.remove('ng-hide');
                scope.showBlur = true;
                infoButton.classList.add('hidden');
            });

            element.on('touchend', () => {
                legend.classList.add('ng-hide');
                scope.showBlur = false;
                infoButton.classList.remove('hidden');
            });

            element.on('contextmenu', (event) => {
                event.preventDefault();
            });
        }
    }
})();
